module.exports = __webpack_public_path__ + "static/media/52692361_2452977061444137_8089263940703354880_o.84d02aba.jpg";